// extracted by mini-css-extract-plugin
module.exports = {"container":"noAccess_container___O44D","title":"noAccess_title__aDkJb"};